import { ref } from "vue";
import { ElLoading } from "element-plus";

const isLoading = ref(false);
let loadingInstance: ReturnType<typeof ElLoading.service> | null = null;
let showTimeout: NodeJS.Timeout | null = null;
let hideTimeout: NodeJS.Timeout | null = null;

/**
 * Show a fullscreen loading overlay after a short delay.
 */
function startLoading(): void {
  if (showTimeout || loadingInstance) return;

  // Optional delay before showing to prevent flashing on fast loads
  showTimeout = setTimeout(() => {
    isLoading.value = true;
    loadingInstance = ElLoading.service({
      lock: true,
      fullscreen: true,
      text: "Loading...",
      background: "rgba(0, 0, 0, 0.2)",
    });
    showTimeout = null;
  }, 100);
}

/**
 * Hide the loading overlay, with a minimum display time to prevent flicker.
 */
function stopLoading(): void {
  if (showTimeout) {
    clearTimeout(showTimeout);
    showTimeout = null;
    return;
  }

  // If already hiding, or nothing to close, skip
  if (hideTimeout || !loadingInstance) return;

  // Wait a bit before closing to avoid flicker
  hideTimeout = setTimeout(() => {
    if (loadingInstance) {
      loadingInstance.close();
      loadingInstance = null;
    }
    isLoading.value = false;
    hideTimeout = null;
  }, 300);
}

/**
 * Composable for global loading overlay control.
 */
export function useLoading() {
  return { isLoading, startLoading, stopLoading };
}
